import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Divider, Tooltip, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WatchIcon from '@mui/icons-material/Watch';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import BedIcon from '@mui/icons-material/Bed';
import CircleIcon from '@mui/icons-material/Circle';
import moment from 'moment';
var getStatusColor = function (status) {
    if (!status || status === '-' || status.toLowerCase() === 'na')
        return '#9ca3af'; // gray
    if (status.toLowerCase() === 'online')
        return '#16a34a'; // green
    if (status.toLowerCase() === 'offline')
        return '#dc2626'; // red
    return '#9ca3af'; // gray
};
var getStatusLabel = function (status) {
    if (!status || status === '-' || status.toLowerCase() === 'na')
        return 'Not Connected';
    return status.charAt(0).toUpperCase() + status.slice(1);
};
var getFormattedDate = function (date) {
    if (!date)
        return 'Not Available';
    // Fix timezone formats:
    // +0000Z  → +00:00
    // +00:00Z → +00:00
    var cleaned = date
        .replace(/(\+\d{4})Z$/, function (_, tz) { return "+".concat(tz.slice(1, 3), ":").concat(tz.slice(3, 5)); })
        .replace(/(\+\d{2}:\d{2})Z$/, '$1');
    var parsed = moment.utc(cleaned);
    return parsed.isValid()
        ? parsed.format('MM/DD/YYYY HH:mm:ss') // UTC output
        : 'Not Available';
};
var DeviceStatusDetailsDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, deviceStatus = _a.deviceStatus;
    var devices = [
        { key: 'watch', label: 'Watch', icon: _jsx(WatchIcon, { sx: { fontSize: 20 } }) },
        { key: 'scale', label: 'Scale', icon: _jsx(MonitorWeightIcon, { sx: { fontSize: 20 } }) },
        { key: 'sleep_mat', label: 'Sleep Mat', icon: _jsx(BedIcon, { sx: { fontSize: 20 } }) },
    ];
    return (_jsxs(Dialog, { open: open, onClose: function (event, reason) {
            if ('stopPropagation' in event && typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            onClose();
        }, onClick: function (e) { return e.stopPropagation(); }, maxWidth: "xs", fullWidth: true, PaperProps: {
            sx: {
                borderRadius: 2,
                p: 0,
            },
        }, children: [_jsxs(DialogTitle, { sx: {
                    fontWeight: 700,
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 2,
                    pb: 1,
                }, children: ["Device Status Details", _jsx(IconButton, { "aria-label": "close", onClick: function (e) {
                            e.stopPropagation();
                            onClose();
                        }, sx: {
                            color: '#64748b',
                            '&:hover': { color: '#1e293b' },
                        }, children: _jsx(CloseIcon, { fontSize: "small" }) })] }), _jsx(Divider, {}), _jsxs(DialogContent, { sx: { p: 2 }, children: [devices.map(function (_a) {
                        var key = _a.key, label = _a.label, icon = _a.icon;
                        var device = deviceStatus[key];
                        var status = (device === null || device === void 0 ? void 0 : device.status) || '-';
                        var color = getStatusColor(status);
                        var statusLabel = getStatusLabel(status);
                        return (_jsxs(Box, { sx: {
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                                py: 1.5,
                                borderBottom: '1px solid #f1f5f9',
                                '&:last-child': {
                                    borderBottom: 'none',
                                },
                            }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [icon, _jsx(Typography, { sx: { fontWeight: 600, fontSize: '0.9rem', color: '#1e293b' }, children: label })] }), _jsxs(Box, { sx: { textAlign: 'right', flex: 1 }, children: [_jsx(Tooltip, { title: "Status: ".concat(statusLabel), children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end',
                                                    gap: 0.5,
                                                    mb: 0.5,
                                                }, children: [_jsx(Typography, { sx: {
                                                            fontSize: '0.8rem',
                                                            color: '#334155',
                                                            fontWeight: 600,
                                                        }, children: statusLabel }), _jsx(CircleIcon, { sx: { fontSize: 10, color: color } })] }) }), _jsxs(Typography, { sx: { fontSize: '0.7rem', color: '#64748b', mb: 0.25 }, children: [_jsx("strong", { children: "Last Measurement Taken :" }), " ", getFormattedDate(device === null || device === void 0 ? void 0 : device.last_ingestion_date)] }), _jsxs(Typography, { sx: { fontSize: '0.7rem', color: '#64748b' }, children: [_jsx("strong", { children: "Last Connected:" }), " ", getFormattedDate(device === null || device === void 0 ? void 0 : device.last_session_date)] })] })] }, key));
                    }), _jsxs(Box, { sx: {
                            mt: 2,
                            p: 1.5,
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            border: '1px solid #e2e8f0',
                        }, children: [_jsxs(Typography, { sx: {
                                    fontSize: '0.75rem',
                                    color: '#475569',
                                    lineHeight: 1.4,
                                    mb: 0.5,
                                }, children: [_jsx("strong", { children: "Last Measurement Taken:" }), " Timestamp (UTC) of last data ingestion into ClearWellness platform."] }), _jsxs(Typography, { sx: {
                                    fontSize: '0.75rem',
                                    color: '#475569',
                                    lineHeight: 1.4,
                                }, children: [_jsx("strong", { children: "Last Connected:" }), " Timestamp (UTC) of last device sync with vendor cloud."] })] })] })] }));
};
export default DeviceStatusDetailsDialog;
